// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ynps","requiredAsterisk":"Info_requiredAsterisk__1rm30"};